module.exports = __webpack_public_path__ + "img/mamdays_shop_button.b8edaa40.png";